import { styled } from 'styled-components';
import { Label } from '.';
const FileInput = ({ label, name, type = 'text', placeholder }) => (
  <Input
    type='file'
    name={name}
    accept='.jpg, .jpeg, .png'
    multiple
  />
);

const Input = styled.input`
  position: relative;
  width: 100%;
  font-size: ${props => props.theme.sizeSmall};
  font-weight: ${props => props.theme.bodyWeightl};
  letter-spacing: ${props => props.theme.headerSpacing};
  text-transform: uppercase;
  overflow: visible;

  &::file-selector-button {
    color: transparent;
    padding: ${props => props.theme.paddingMd};
    width: calc(
      (2 * ${props => props.theme.spaceMd}) + (14 * ${props => props.theme.sizeBody})
    );
    margin-right: ${props => props.theme.spaceMd};

    background-color: transparent;

    border: 2px solid ${props => props.theme.mutedColor};
    border-radius: ${props => props.theme.borderFull};

    cursor: pointer;
    transition: ${props => {
      return ['background-color', 'border-color', 'color', 'box-shadow']
        .map(style => `${style} ${props.theme.transition}`)
        .join(',');
    }};
  }
  &::after {
    content: 'Upload references';
    position: absolute;
    top: calc(${props => props.theme.spaceSm} + 2px);
    left: calc(${props => props.theme.spaceMd} + 2px);

    font-size: ${props => props.theme.sizeBody};
    font-weight: ${props => props.theme.headerWeight};
    letter-spacing: ${props => props.theme.headerSpacing};
    text-transform: uppercase;
    color: ${props => props.theme.mutedColor};
    pointer-events: none;

    transition: ${props => {
      return ['background-color', 'border-color', 'color', 'box-shadow']
        .map(style => `${style} ${props.theme.transition}`)
        .join(',');
    }};
  }

  &:hover {
    &::file-selector-button {
      background-color: ${props => props.theme.brand};
      border-color: ${props => props.theme.brand};
    }

    &::after {
      color: ${props => props.theme.backgroundColor};
    }
  }
`;

export default FileInput;
